import type { SelectOption } from '@tryhackme/thm-ui-components';

export const INFLUENCERS_CAMPAIGNS_URL = '/campaigns/influencers';

export const SelectOptions = [
  {
    id: '1',
    value: '10',
    label: '10',
  },
  {
    id: '2',
    value: '25',
    label: '25',
  },
  {
    id: '3',
    value: '100',
    label: '100',
  },
];

export const defaultOption: SelectOption = { id: '1', value: '10', label: '10' };
